import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { hideConfirmCandidateAnotherJobPopup } from '../../../actions';
import AnimatedCheckCircle from '../../shared/AnimatedCheckCircle';
import ConfirmPopup from '../../shared/ConfirmPopup';

export const ConfirmCandidateAnotherJobPopup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const job = useSelector((state) => state.job.job);
  const { show, candidate, officeId } = useSelector(
    (state) => state.job.confirmCandidateAnotherJobPopup,
  );
  const pendingJobs = useSelector((state) => state.job.actionRequiredJobs);

  if (!show || !job || !candidate) {
    return null;
  }

  return (
    <ConfirmPopup
      Icon={() => (
        <div style={{ marginBottom: 20 }}>
          <AnimatedCheckCircle />
        </div>
      )}
      title={`Candidate Confirmed for ${job?.local_date}!`}
      description={
        <span>
          {candidate?.full_name} has also applied to another shift at your office. Would you like to
          review their application?
        </span>
      }
      rightButtonAction={() => {
        navigate(`/offices/${officeId}/candidates/${candidate?.id}/jobs`);

        dispatch(hideConfirmCandidateAnotherJobPopup());
      }}
      rightButtonText="Review"
      leftButtonText="No Thanks"
      leftButtonAction={() => {
        dispatch(hideConfirmCandidateAnotherJobPopup());
        navigate(`/dashboard/jobs/${pendingJobs?.length > 0 ? 'pending' : 'scheduled'}`);
      }}
    />
  );
};
